import { useEffect } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ProfileProvider } from './contexts';
import { BaristaProvider } from './contexts/BaristaContext';
import { NotificationsProvider } from './contexts/NotificationsContext';
import Dashboard from './screens/Admin/Dashboard'
import SetupAdmin from './screens/Admin/SetupAdmin'
import StaffDashboard from './screens/Staff/StaffDashboard'
import POSLayout from './screens/Staff/POSLayout';
import CoffeeHome from './screens/CoffeeHome'
import Login from './screens/Login'
import StaffSetup from './screens/Staff/StaffSetup'
import './index.css'


import { useNetworkStatus } from './offline/useNetworkStatus'
import { runSync } from './offline/syncEngine'

function ProtectedLogin({ children }) {
  const isAuthorized = sessionStorage.getItem('secretCodeEntered') === 'true';
  if (!isAuthorized) return <Navigate to="/" replace />;
  return children;
}

function ProtectedRoute({ children, requiredType = null }) {
  const isAuth =
    localStorage.getItem('isAuthenticated') === 'true' ||
    sessionStorage.getItem('isAuthenticated') === 'true'

  const userType =
    localStorage.getItem('userType') ||
    sessionStorage.getItem('userType')

  if (!isAuth) return <Navigate to="/" replace />
  if (requiredType && userType !== requiredType) return <Navigate to="/" replace />
  return children
}

function App() {

  useNetworkStatus()

  useEffect(() => {
    const handleOnline = () => { runSync() }
    window.addEventListener('online', handleOnline)
    if (navigator.onLine) runSync() // in case pending items were queued before app load
    return () => window.removeEventListener('online', handleOnline)
  }, [])
  
  return (
    <ProfileProvider>
      <BrowserRouter>
        <BaristaProvider>
        <NotificationsProvider>
        <Routes>
          <Route path='/' element={<CoffeeHome />} />

          <Route path="/login" element={
            <ProtectedLogin><Login /></ProtectedLogin>
          } />

          <Route path='/setup-admin' element={
            <ProtectedRoute requiredType="admin"><SetupAdmin /></ProtectedRoute>
          } />
          <Route path="/dashboard" element={
            <ProtectedRoute requiredType="admin"><Dashboard /></ProtectedRoute>
          } />
            <Route path="/staff-dashboard" element={
              <ProtectedRoute requiredType="staff">
                  <StaffDashboard />
              </ProtectedRoute>
          } />
          <Route path='/staff-setup' element={
            <ProtectedRoute requiredType="staff"><StaffSetup /></ProtectedRoute>
          } />
          <Route path='/pos' element={
            <ProtectedRoute requiredType="staff"><POSLayout /></ProtectedRoute>
          } />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </NotificationsProvider>
        </BaristaProvider>
      </BrowserRouter>
    </ProfileProvider>
  );
}

export default App;